export enum SuggestionStatus {
  Pending = 'Pending',
  Completed = 'Completed',
  Ignored = 'Ignored',
}

export enum SuggestionIconType {
  Completed = 'completed',
  Ignored = 'ignored',
}

export enum SuggestionAccordionState {
  Collapsed = 'collapsed',
  Expanded = 'expanded',
}
